<template>
  <div class="loading-overlay">
    <span class="loader" />
  </div>
</template>

<script>

export default {

}
</script>

<style lang="scss" scoped>

.loading-overlay {
  z-index: 20;
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100vw;
  height: 100vh;
  background-color: rgba(black, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;

  .loader {
    width: 100px;
    height: 100px;
    border: 5px solid #FFF;
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
    }

    @keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
  }
}
</style>
